/**
 * Main Category filter - free-text substring match against the resolved
 * product category root name. Use the `NO_CATEGORY_VALUE` sentinel to
 * filter to products without a category (mirrors `formatMainCategory`).
 */
import React from 'react'
import { TextField, Typography, Box, InputAdornment, Tooltip, IconButton } from '@mui/material'
import { HelpOutline } from '@mui/icons-material'
import { NO_CATEGORY_VALUE, NO_CATEGORY_LABEL } from '../../../../utils/productCategory'

interface MainCategoryFieldProps {
  value: string
  onChange: (value: string) => void
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const MainCategoryField: React.FC<MainCategoryFieldProps> = ({ value, onChange }) => (
  <Box>
    <Typography component="label" sx={labelStyle}>Main Category</Typography>
    <TextField
      fullWidth
      size="small"
      placeholder={`e.g. "Chemicals" or "${NO_CATEGORY_LABEL}"`}
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={`Type a category name (substring match). Use exactly "${NO_CATEGORY_LABEL}" to filter products without a category.`}>
              <IconButton
                size="small"
                onClick={() => onChange(NO_CATEGORY_VALUE)}
                title="Filter to 'No category'"
              >
                <HelpOutline fontSize="small" />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    />
  </Box>
)

export default MainCategoryField
